/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 9999eb1d882990f19e352fba26b6c3f62977c8a7
 */

/**
 * Why a consumption cycle (layer) was closed.
 *
 * Crossing ``max_consumption_threshold`` is a milestone stamp, not a close —
 * a layer keeps accumulating up to 100% and dies only with its group
 * generation: when the window passes or the rate regime changes.
 */
export type CycleCloseReason = typeof CycleCloseReason[keyof typeof CycleCloseReason];


export const CycleCloseReason = {
  expired: 'expired',
  rate_changed: 'rate_changed',
} as const;
